/**
 * Author: Andrey Morozov
 * Confidential. Proprietary code. Do not distribute without authorization.
 *
 * SettingsPage.tsx — Setting\1 \2age (services/operator-web-app).
 */

/**
 * Settings: audio devices (E3-S2), account (Plan 2.1 login), theme, future: notifications.
 */
import { useNavigate } from 'react-router-dom';
import { useStore } from 'zustand';
import { AudioDeviceSelect } from '@/features/call/AudioDeviceSelect';
import { Button } from '@/components/ui';
import { getOperatorId, setOperatorId } from '@/config/env';
import { operatorStore } from '@/store/operatorStore';
import { themeStore } from '@/store/themeStore';
import { useTranslation } from '@/i18n';

export function SettingsPage() {
  const t = useTranslation();
  const navigate = useNavigate();
  const theme = useStore(themeStore, (s) => s.theme);
  const setTheme = useStore(themeStore, (s) => s.setTheme);

  const handleLogout = () => {
    operatorStore.getState().disconnect();
    setOperatorId('');
    navigate('/login', { replace: true });
  };

  return (
    <div className="py-6 space-y-6">
      <h1 className="text-lg font-semibold" style={{ color: 'var(--text-primary)' }}>
        {t('settings.title')}
      </h1>

      <section
        className="rounded-lg border p-3 text-sm glass-panel"
        aria-labelledby="theme-heading"
      >
        <h2
          id="theme-heading"
          className="font-medium mb-2"
          style={{ color: 'var(--text-primary)' }}
        >
          {t('settings.theme')}
        </h2>
        <div className="flex gap-2">
          <Button
            variant={theme === 'light' ? 'primary' : 'secondary'}
            size="sm"
            onClick={() => setTheme('light')}
            aria-pressed={theme === 'light'}
          >
            {t('settings.light')}
          </Button>
          <Button
            variant={theme === 'dark' ? 'primary' : 'secondary'}
            size="sm"
            onClick={() => setTheme('dark')}
            aria-pressed={theme === 'dark'}
          >
            {t('settings.dark')}
          </Button>
        </div>
      </section>

      <section
        className="rounded-lg border p-3 text-sm glass-panel"
        aria-labelledby="account-heading"
      >
        <h2
          id="account-heading"
          className="font-medium mb-2"
          style={{ color: 'var(--text-primary)' }}
        >
          {t('settings.account')}
        </h2>
        <p className="mb-2" style={{ color: 'var(--text-secondary)' }}>
          {t('settings.current_operator')}{' '}
          <code className="font-mono" style={{ color: 'var(--text-primary)' }}>
            {getOperatorId()}
          </code>
        </p>
        <Button variant="ghost" size="sm" onClick={handleLogout}>
          {t('settings.logout')}
        </Button>
      </section>

      <AudioDeviceSelect />
    </div>
  );
}
